export default "__VITE_ASSET__lilDzATL__"